import { Component } from '@angular/core';

@Component({
  templateUrl: 'register.component.html'
})
export class RegisterComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/pages/register.component.ts